import { useEffect } from 'react';
import { useController, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { Common } from '@thecvlb/design-system';

import EmailInput from 'shared/form/EmailInput';

import { PathName } from 'utils/enums';

import { ContinueWithEmailFormProps, FormInputs } from './continueWithEmailForm.types';

const ContinueWithEmailForm: React.FC<ContinueWithEmailFormProps> = ({
  onSubmit,
  predefinedEmail
}) => {
  const { handleSubmit, control, setValue } = useForm<FormInputs>({
    mode: 'onChange',
    reValidateMode: 'onChange'
  });

  const { formState, field } = useController({
    control,
    defaultValue: '',
    name: 'password',
    rules: {
      required: {
        message: 'Password is required',
        value: true
      }
    }
  });

  useEffect(() => {
    if (predefinedEmail) {
      setValue('email', predefinedEmail);
    }
  }, []);

  return (
    <form
      className="relative flex w-full flex-col items-center gap-8"
      role="form"
      onSubmit={handleSubmit(onSubmit)}
    >
      <h1 className="px-[30px] text-center text-mLg font-bold text-white md:text-lg md:text-gray-700">
        Sign in
      </h1>
      <div className="flex w-full flex-col items-center gap-4 md:gap-3">
        <EmailInput
          control={control}
          dataTestId="email"
          label="Email"
          labelClassName="max-md:!text-white"
          name="email"
        />
        <Common.Input
          dataTestId="password"
          title="password"
          {...field}
          errors={formState.errors[field.name]}
          helper={formState.errors[field.name]?.message?.toString()}
          label="Password"
          labelClassName="max-md:!text-white"
          maxLength={100}
          placeholder="**********"
          type="password"
        />
      </div>
      <div className="flex w-full flex-col items-center gap-4">
        <Common.Button
          className="!w-full"
          color="blue-alt"
          dataTestId={'sign_in_btn'}
          type="submit"
          fullWidthOnMobile
        >
          Sign in
        </Common.Button>
        <Link
          className="text-mBase font-semibold text-white max-sm:p-5 md:text-base md:text-gray"
          data-testid="forgot_pass_btn"
          to={PathName.ForgotPassword}
        >
          Forgot your password?
        </Link>
      </div>
    </form>
  );
};

export default ContinueWithEmailForm;
